import $ from "jquery";
import Backbone from "backbone";
import { getTransitionPromise } from "nexia_mobile/components/Routing/HistoryPageTransitionController";

// We patch Backbone.sync here so that it doesn't resolve/reject until page
// transitions are done. We do this because we do a bunch of parsing logic as
// the result of a Backbone.sync and we don't want to block the main thread
// during a page transition because that will make the transition freeze up on
// mobile devices.
export default function patchBackboneSync() {
  const originalSync = Backbone.sync;
  Backbone.sync = function sync(...args) {
    const jqXHR = originalSync.apply(this, args);
    const deferred = $.Deferred();
    jqXHR.then((...responseArgs) => {
      getTransitionPromise().then(() => {
        deferred.resolve(...responseArgs);
      });
    });

    jqXHR.catch((...errorArgs) => {
      getTransitionPromise().then(() => {
        deferred.reject(...errorArgs);
      });
    });

    deferred.abort = jqXHR.abort;

    return deferred;
  };
}



// WEBPACK FOOTER //
// ./src/patchBackboneSync.js